module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom3.08b2e3a4.jpg";